export default __webpack_public_path__ + "static/media/erx-lalamove-icon.c16d9aff.svg";